import React from "react";
import { IBox } from "./styles";

export default function InfoBox(props) {
  return <IBox>{props.children}</IBox>;
}
